import {t} from '../../../../../localization';
import {weekdayFormatter} from './weekdayFormatter';

export const weekFormatter = (
  weeks: number,
  weekdays: string[],
  state: Array<Array<boolean>>,
) => {
  return new Array(weeks)
    .fill(0)
    .map((_, week) => {
      const weekdayIndices = state[week]
        .map((p, i) => (p ? i + 1 : undefined))
        .filter(p => p !== undefined) as number[];

      return `${t('screens.member.fields.availability.week', {
        week: week + 1,
      })} ${weekdayFormatter(weekdays, weekdayIndices)}`;
    })
    .join(', ');
};
